import * as React from 'react';

import { Product } from '../interfaces';
import { createUseStyles } from 'react-jss';
import { useIntl } from '../providers';

interface ProductDownloadsProps {
    product: Product;
}

const useStyles = createUseStyles({
    productDownloads: {},
});

const ProductDownloads: React.FC<ProductDownloadsProps> = ({ product }: ProductDownloadsProps) => {
    const classes = useStyles();
    const { translate } = useIntl();
    const { downloads } = product;

    return (
        <div className={classes.productDownloads}>
            <strong>{translate('productDownloads.header', 'Downloads')}</strong>
            <ul>
                {downloads.map((download, i) => (
                    <li key={i}>
                        <a href={download.url} title={download.label} download>
                            {download.label}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default React.memo(ProductDownloads);
